import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutomationApi } from '../../api/automation-api';
import { Company } from '../../models/company/dto/company';
import { Location } from '../../models/company/dto/location';
import { ScheduledEmail } from '../../models/automation/scheduled-email';
import { FileSystemService } from '../../services/file-system.service';
import { Repository } from '../base/repository';

/**
 * Data-access layer for scheduled menu sending.
 *
 * Deliberately uncached. A send schedule is read when the user opens the scheduling screen to edit it, and showing
 * a cached schedule there would invite an edit against a version the server has already moved past. The
 * `FileSystemService` dependency is only here because the base constructor requires it.
 */
@Injectable()
export class ScheduledMenuRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected automationAPI: AutomationApi
  ) {
    super(fileSystemService);
  }

  public getScheduledMenuSending$(company: Company, location: Location): Observable<ScheduledEmail[]> {
    return this.automationAPI.getScheduledMenuSending$(company, location);
  }

  public updateScheduledEmail$(scheduledEmail: ScheduledEmail): Observable<ScheduledEmail> {
    return this.automationAPI.updateScheduledEmail$(scheduledEmail);
  }
}
